<!-- Localized -->
<template>
    <div class="flex flex-1 flex-col h-full text-base-content" v-allow:auth="'users.read'" >
        <sub-header :backButton="true" />
        <div class="flex flex-col overflow-hidden bg-card-bg rounded-xl shadow">
            <div class="flex items-center justify-center flex-1 py-16 rounded-md flex-col" v-if="loading"><Loader class="my-5" :size="8" />{{ $t('general.loading') }}</div>
            <div v-else class="p-6 gap-5 user-form__grid">
                <div  class="flex justify-center gap-6 pr-1 overflow-auto scroll-bar" v-if="userDetails">
                    <div class="flex gap-6 flex-col w-full pt-11">
                        <div class="flex flex-col gap-2">
                            <span class="text-base-content-300 text-md">{{ $t('pages.user_details.user_name') }}</span>
                            <neo-input :disabled="!userPermission"  class="rounded-lg h-10 w-full" :placeholder="$t('pages.user_details.group_name')" bg="white" v-model="userDetails.user_name"> </neo-input>
                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-base-content-300 text-md">{{ $t('pages.user_details.email') }}</span>
                            <neo-input disabled  class="rounded-lg h-10 w-full" :placeholder="$t('pages.user_details.assigned_client')" bg="white" v-model="userDetails.email"> </neo-input>
                        </div>
                        <div class="flex flex-row w-full justify-between gap-6">
                            <div class="flex flex-col flex-grow  gap-2">
                                <span class="text-base-content-300 text-md">{{ $t('pages.user_details.assigned_roles') }}</span>
                                <vue-multiselect
                                :disabled="!userPermission"
                                class="w-full"
                                    :multiple="true"
                                    
                                    :placeholder="$t('pages.user_details.select_a_roles_to_add')"
                                    :show-labels="false"
                                    :maxHeight="200"
                                    :options="roleOptions"
                                    v-model="roleValue"
                                    :loading="loading"
                                    :colors="dropdownColors"
                                    :config="dropdownConfig"
                                    minWidth="100%"
                                    :reposition="true"
                                    showCheckBox
                                    :value="roleValue"
                                />
                            </div>
                            <div class="flex flex-col flex-grow gap-2">
                                <span class="text-base-content-300 text-md">{{ $t('pages.user_details.assigned_groups') }}</span>

                                <vue-multiselect
                                    class="w-full"
                                    :disabled="!userPermission || !checkPermission('groups.read')"
                                    :multiple="true"
                                    showCheckBox
                                    :placeholder="$t('pages.user_details.select_a_groups_to_add')"
                                    :show-labels="false"
                                    :options="groupOptions"
                                    v-model="groupValue"
                                    :loading="loading"
                                    :colors="dropdownColors"
                                    :config="dropdownConfig"
                                    minWidth="100%"
                                    :reposition="true"
                                    :value="groupValue"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-6 w-full">
                        <div class="flex justify-end">
                        <span class="font-bold p-2 px-4">{{ $t('pages.user_details.api_tokens') }}</span>
                        <neo-button v-if="!isTokenGenerated && !isApiKey" :text="$t('pages.user_details.generate')" type="primary" class="text-white-text"  @click="generateToken" />
                        <neo-button v-if="isTokenGenerated || isApiKey" :text="$t('pages.user_details.regenerate')" type="primary" class="text-white-text ml-4"  @click="regenerateToken" />
                        <neo-button v-if="isTokenGenerated || isApiKey" :text="$t('pages.user_details.revoke')" type="outline" class="ml-4 text-blue-600 bg-white" @click="revokeToken"/>
                        </div>
                        <div v-if="isTokenGenerated"><p>{{ $t('pages.user_details.if_you_loose_or_forget_your_secret_key_you_cannot_retrive_it') }}<br/>{{ $t('pages.user_details.generate_a_new_access_and_secret_keys') }}</p></div>
                        <div class="flex flex-col gap-2" v-if="isTokenGenerated ||isApiKey">
                            <span class="text-base-content-300 text-md">{{ $t('pages.user_details.api_key') }}</span>
                            <div class="form-control relative">
                                <input type="text" v-model="apiToken" ref="api" class="input rounded-lg h-10 w-full lg:w-full input-bordered border-box-stroke focus:border-primary "/>
                                <font-awesome-icon icon="copy" ref="copy" class="text-blue-500 hover:text-blue-600 absolute right-4 top-3 cursor-pointer outline-none " @click="copyApiKey()" v-tippy='{ arrow : true, theme : "light bordered", trigger : "click"}' :content="$t('pages.user_details.api_key_copied')"/>
                            </div>
                        </div>    
                        <div class="flex flex-col gap-2" v-if="isTokenGenerated">
                            <span class="text-base-content-300 text-md">{{ $t('pages.user_details.secret') }}</span>
                            <div class="form-control relative" :style="`${disableCopy ? 'pointer-events: none; cursor:not-allowed' : ''}`">
                                <input type="password" ref="secret" v-model="secretkey" :disabled="disableCopy"  class="input rounded-lg h-10 w-full lg:w-full input-bordered border-box-stroke focus:border-primary " :class="`${disableCopy ? 'text-gray-500':''}`"  :style="`${disableCopy ? 'pointer-events: none; cursor:not-allowed' : ''}`"/>
                                <span class="text-sm ml-2 top-2 underline" style="position:absolute; right:38px; cursor:pointer"  v-if="!disableCopy" :class="disableCopy ? 'text-gray-500' : 'text-blue-600' " @click="toggleKey()">{{!isKeyVisible ? $t('actions.show') : $t('actions.hide')}}</span>
                                <font-awesome-icon icon="copy" ref="btn" class="absolute right-4 top-3  cursor-pointer outline-none " @click="copySecretKey()" v-tippy='{ arrow : true, theme : "light bordered", trigger : "click", allowHTML:true}' :content="$t('pages.user_details.api_secret_key_copied')" :class="`${disableCopy ? 'text-gray-500' : 'text-blue-500 hover:text-blue-600'}`"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4 flex justify-end max-w-full gap-4">
                    <neo-button v-if="checkPermission('users.edit')" :text="$t('pages.user_details.delete_user')" icon="trash" type="error" class="text-white-text"  v-allow="'users.delete'" @click="deleteUser" />
                    <neo-button :text="$t('actions.save')" icon="check" type="primary" class="text-white-text" v-allow="'users.edit'" @click="updateUser" />
                </div>
            </div>
        </div>

        <!-- delete popup confirm -->
        <modal-confirm :title="$t('general.are_you_sure')" :message="$t('pages.user_details.please_confirm_youre_about_to_delete_the_field')" ref="confirm-popup"> </modal-confirm>
    </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import Input from "@/components/input";
import Button from "@/components/button";
import axios from "@/axios";
import Loader from "@shared/loader";
import Dropdown from "@shared/components/dropdown-base";
const modalConfirm = () => import("@/components/modal-confirm");
import { checkPermission } from "@shared/utils/functions";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
    name: "field-table-data-view",

    components: {
        SubHeader,
        "neo-input": Input,
        "neo-button": Button,
        "vue-multiselect": Dropdown,
        modalConfirm,
        Loader,
        'font-awesome-icon': FontAwesomeIcon,
    },

    data: () => ({
        roleValue: [],
        groupValue: [],
        roleOptions: [],
        groupOptions: [],
        loading: false,
        userDetails: null,
        tenant_id: null,
        user_id: null,
        allRemoved: false,
        oldRoleValue:[],
        oldGroupValue:[],
        apiToken: null,
        secretkey: null,
        isKeyVisible: false,
        isTokenGenerated: false,
        disableCopy: false,
        isApiKey: false
    }),

    async mounted() {
        this.user_id = this.$route.params.id;
        this.tenant_id = this.$store.getters.getTenantId;
        await this.fetchUserDetails();
        await this.fetchUserGroups();
        await this.fetchUserRoles();
        await this.getToken();
    },

    computed: {
        userPermission(){
            return this.checkPermission('users.edit')
        },
        dropdownConfig() {
            return {
                limit: 1,
                label: 'title',
                trackBy: 'id'
            };
        },
        dropdownColors() {
            return {
                text: '#282828',
                bg: 'white',
                svg: '#282828',
                border: '#e8e8e8',
            };
        },
    },

    watch: {
        groupValue(_, oldVal) {
            oldVal.forEach((e)=>{
                this.oldGroupValue.push(e)
            })
        },
        roleValue(_, oldVal) {
            oldVal.forEach((e)=>{
                this.oldRoleValue.push(e)
            })
        }
    },

    methods: {
        checkPermission,

        async fetchUserGroups() {
            if (!this.checkPermission('groups.read')) return
            let { data } = await axios.get(`group/tenant/${this.tenant_id}`);
            this.groupOptions = data;
        },
        async fetchUserRoles() {
            // if (!this.checkPermission('role.read')) return
            let { data } = await axios.get(`role/tenant/${this.tenant_id}`);
            this.roleOptions = data;
        },
        async fetchUserDetails() {
            
            this.loading = true;
            const url = `/user/tenant/${this.tenant_id}/user/${this.user_id}`;
            try {
                const { data } = await axios.get(url);
                this.roleValue = data.role_ids.map(el => ({...el, id: el.role_id}))
                this.groupValue = data.group_ids.map(el => ({...el, id: el.group_id}))
                this.userDetails = data;
            } catch (error) {
                this.$toast.warning(error.response.data.detail || this.$t('pages.user_details.warning_user_details_not_found'));
            }
            this.loading = false;
        },
        async updateUser() {
            const group_ids = this.groupValue.map((x) => ({ group_id: x.id }));
            const role_ids = this.roleValue.map((x) => ({ role_id: x.id }));
            try {
                let { data } = await axios.put("user/", {
                    id: this.userDetails.id,
                    email: this.userDetails.email,
                    user_name: this.userDetails.user_name,
                    group_ids: group_ids,
                    role_ids: role_ids,
                });
                this.$toast.success(data.message || this.$t('pages.user_details.success_user_update'));
                this.$router.back();
            } catch (error) {
                this.$toast.error(error.response.data.detail || this.$t('pages.user_details.error_user_update'));
                console.log("error", error);
                
                if(!this.groupValue.length){
                    const uniqueArray = []
                    const uniqueIds = new Set();
                    for(const item of this.oldGroupValue){
                        
                        if (!uniqueIds.has(item.id)) {
                            uniqueIds.add(item.id);
                            uniqueArray.push(item);
                            }
                    }
                    this.groupValue = uniqueArray;
                }
                if(!this.roleValue.length){
                    const uniqueArray = []
                    const uniqueIds = new Set();
                    for(const item of this.oldRoleValue){
                        if (!uniqueIds.has(item.id)) {
                            uniqueIds.add(item.id);
                            uniqueArray.push(item);
                            }
                    }
                    this.roleValue = uniqueArray;
                }
                
                this.allRemoved = true;
            }
        },
        async deleteUser() {
            const promise = await this.$refs["confirm-popup"].show({
                title: this.$t('general.are_you_sure'),
                message: this.$t('pages.user_details.confirm_user_delete'),
            });
            if (promise) {
                try {
                    console.log("delete user api called on id:", this.user_id);
                    let { data } = await axios.delete(`user/${this.user_id}`);
                    this.$toast.success(data.message || this.$t('pages.user_details.success_user_delete'));
                    this.$router.back();
                } catch (error) {
                    this.$toast.error(error.response.data.detail || this.$t('pages.user_details.error_user_delete'));
                }
            }
            this.$refs["confirm-popup"].close();
        },
        async generateToken() {
            const apiToken = await axios.get(`user-api-token/generate?user_id=${this.user_id}`);
            if(apiToken.status) {
                this.apiToken = apiToken?.data?.data?.api_key;
                this.secretkey = apiToken?.data?.data?.secret;
                this.isTokenGenerated = true;
                this.$toast.message(apiToken.message)
            }  
        },
        async regenerateToken() {
            this.disableCopy = false;
            const apiToken = await axios.post('user-api-token/re-generate',{'api_key':this.apiToken, 'user_id':this.user_id});
            if(apiToken.status) {
                this.apiToken = apiToken?.data?.data?.api_key;
                this.secretkey = apiToken?.data?.data?.secret;
                this.isTokenGenerated = true;
                this.$toast.message(apiToken.message)
            }  
        },
        async getToken() {
            this.disableCopy = false;
            const apiToken = await axios.get(`user-api-token?user_id=${this.user_id}`);
            if(apiToken.status&& apiToken?.data?.data?.length>0) {
                this.apiToken = apiToken?.data?.data[0]?.api_key;
                this.isApiKey= true;
            }  
        },
        toggleKey() {
            this.$refs.secret.type = this.$refs.secret.type === "text" ? "password" : "text";
            this.isKeyVisible = !this.isKeyVisible;
        },
        copySecretKey() {
            this.$refs.secret.type = "text";
            const element = this.$refs.secret;
            element.select();
            document.execCommand('copy');
            var that = this;
            that.$refs.btn._tippy.color ="green"
            setTimeout(function() { that.$refs.btn._tippy.show(); }, 100);
            this.keyCopied();
            this.disableCopy = true;
        },
        copyApiKey() {
            const element = this.$refs.api;
            element.select();
            document.execCommand('copy');
            var that = this;
            setTimeout(function() { that.$refs.copy._tippy.show(); }, 100);
            this.apiCopied();
        },
        apiCopied() {
            var that = this;
            setTimeout(function() { that.$refs.copy._tippy.hide(); }, 2000);
        },
        keyCopied() {
            var that = this;
            this.$refs.secret.type = "password";
            setTimeout(function() { that.$refs.btn._tippy.hide(); }, 2000);
        },
        async revokeToken() {
            this.isTokenGenerated = false;
            await this.getToken()
        }
    },
};
</script>

<style lang="scss">
.tippy-tooltip {
    &.light-theme{
        color: green;
    }
}
</style>
<style scoped lang="scss">
.show{
    position:absolute;
}

.user-form__grid {
    display: grid;
    grid-template-rows: 1fr auto;
    height: 100%;
    overflow: hidden;
}
</style>
